import React from 'react';
import PropTypes from 'prop-types';
import css from './ReservationProfileDetails.module.scss';
import DetailRow from '../DetailRow/DetailRow.jsx';
import ReservationProfileSectionTitle from './ReservationProfileSectionTitle.jsx';

const ReservationSegmentationDetails = ({reservationProfile}) => {
  return (
    <div className={css.reservationDetails}>
      <ReservationProfileSectionTitle>Segmentation</ReservationProfileSectionTitle>
      <DetailRow label="Rate Code" value={reservationProfile.ratePlan} />
      <DetailRow label="Market Segment" value={reservationProfile.marketSegment} />
      <DetailRow label="Source" value={reservationProfile.reservationSource} />
      <DetailRow label="Membership Level" value={reservationProfile.guest?.membershipLevel} />
    </div>
  );
};

ReservationSegmentationDetails.propTypes = {
  reservationProfile: PropTypes.shape({
    ratePlan: PropTypes.string,
    marketSegment: PropTypes.string,
    reservationSource: PropTypes.string,
    guest: PropTypes.shape({
      membershipLevel: PropTypes.string,
    }),
  }).isRequired,
};

export default ReservationSegmentationDetails;
